import { success } from "toastr";
import {
  FETCH_TASK_TYPE,
  FETCH_TASK_TYPE_SUCCESS,
  FETCH_TASK_TYPE_FAILURE,
  FETCH_TASK_TYPE_MODE,
  FETCH_TASK_TYPE_MODE_SUCCESS,
  FETCH_TASK_TYPE_MODE_FAILURE,  
  FETCH_TASK_TYPE_MODE_CLEAR,
  SAVE_TASK_TYPE,
  SAVE_TASK_TYPE_SUCCESS,
  SAVE_TASK_TYPE_FAILURE,
  CHANGE_TASK_TYPE_STATUS,
  CHANGE_TASK_TYPE_STATUS_SUCCESS,
  CHANGE_TASK_TYPE_STATUS_FAILURE
} from "./actionTypes";

const initialState = {
  taskType: [],
  typeMode: [],
  loading: false,
  error: null,
  success:false
};

const timesheetSetupTaskTypeReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_TASK_TYPE:
      return { ...state, loading: true };
    case FETCH_TASK_TYPE_SUCCESS:
      return { ...state, loading: false, taskType: action.payload.data};
    case FETCH_TASK_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };    
    case FETCH_TASK_TYPE_MODE:
      return { ...state, loading: true, success: false };
    case FETCH_TASK_TYPE_MODE_SUCCESS:
      return { ...state, loading: false, success: false, 
        typeMode:(action.payload?.data).map(md => ({
          value: md.mode_id,
          label: md.mode_name
        })),
      }; 
    case FETCH_TASK_TYPE_MODE_CLEAR:
      return { ...state, loading: false, success: false, typeMode: '' };     
    case FETCH_TASK_TYPE_MODE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
    case CHANGE_TASK_TYPE_STATUS:
      return { ...state, loading: true, error: null, success: false };
    case CHANGE_TASK_TYPE_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };
    case CHANGE_TASK_TYPE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    case SAVE_TASK_TYPE:
      return { ...state, loading: true, success:false, error: null };    
    case SAVE_TASK_TYPE_SUCCESS:
      return { ...state, loading: false, success:true, error: null };
    case SAVE_TASK_TYPE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };           
    default:
      return state;
  }
};

export default timesheetSetupTaskTypeReducer;
